import { apiVersionService } from '@/services/api-version'
import { GET_API_VERSION, MERGE_API_VERSION } from '@/store/mutation-types'

export const namespaced = false
export const state = {
  api: {}
}
export const mutations = {
  [MERGE_API_VERSION](state, version) {
    state.api = version.app
  }
}
export const actions = {
  async [GET_API_VERSION]({ commit }) {
    const data = await apiVersionService.get()
    commit(MERGE_API_VERSION, data)
  }
}
